import SoundboardLayoutStep from './SoundboardLayoutStep';
import WordSelectionStep from './WordSelectionStep';
import ReviewStep from './ReviewStep';

const SetupWizardSteps = [
  SoundboardLayoutStep,
  WordSelectionStep,
  ReviewStep
];

export default SetupWizardSteps;